import React from 'react';
import '../static/css/reglogin.css';
import {NavLink, withRouter} from 'react-router-dom';
import axios from 'axios';
import NotificationSystem from 'react-notification-system';

class Login extends React.Component {
    _notificationSystem = null

    constructor(props) {
        super(props);
        this.state = {
            email: '',
            password: ''

        }
    }

    _addNotification = (level, msg) => {
        //event.preventDefault();
        this._notificationSystem.addNotification({
            message: msg,
            level: level
        });
    }

    componentDidMount() {
        this._notificationSystem = this.refs.notificationSystem;

    }

    getLogIn = (e) => {
        e.preventDefault();
        axios.post(`${process.env.REACT_APP_BACKEND_URL}/user/login`, this.state)
            .then(res => {
                console.log('res', res.data);

                this._addNotification("success", "You have successfully Logged In.");
                if (res.status === 200) {
                    console.log(res.data);
                    localStorage.setItem("UserObject", JSON.stringify(res.data));
                    // this.props.history.push('/myaccount')
                    window.location='/myaccount';
                }
            })
            .catch(err => {
                console.log('error', err)
                if (err.response && err.response.status === 401) {
                    this._addNotification("error", `${err.response.data.msg}`);
                }
                console.error(err.response);
                let errors = err.response.data.errors === undefined ? [] : err.response.data.errors;

                for (let i = 0; i < errors.length; i++) {
                    this._addNotification("error", `${i + 1} -> ${errors[i].param}: ${errors[i].msg}`)
                }
            });

    }

    render() {
        return (
            <div>
                <div className="container">
                    <div id="loginarea" className="p-2">
                        <h6 className="text-center" style={{fontWeight: 'bold'}}>LogIn</h6>
                        <div id="login" className="form-bg p-2 pb-4">
                            <form method="POST" onSubmit={this.getLogIn}>
                                <div className="form-group" id="iconlogin">
                                    <input type="email"
                                           value={this.state.email}
                                           onChange={(e) => {
                                               this.setState({email: e.target.value})
                                           }}
                                           className="form-control" name="email" id="email" aria-describedby="emailHelp"
                                           placeholder="Enter email"/>
                                    <i className="fas fa-envelope"/>
                                    <small id="emailHelp" className="form-text text-muted">We'll never share your email
                                        with anyone else.
                                    </small>
                                </div>
                                <div className="form-group" id="iconlogin2">
                                    <input type="password"
                                           value={this.state.password}
                                           onChange={(e) => {
                                               this.setState({password: e.target.value})
                                           }}
                                           className="form-control" name="password" id="password"
                                           placeholder="Password"/>
                                    <i className="fas fa-unlock-alt"/>
                                </div>


                                <button type="submit" className="btn btn-outline-primary btn-block p-2">Submit</button>
                                <div>
                                    <p className="acfl">Forgot Password?</p>
                                    <NavLink to='/user/register'><p className="acfr">New User? Register Here</p>
                                    </NavLink>
                                </div>
                            </form>

                        </div>

                    </div>
                </div>
                <NotificationSystem ref="notificationSystem"/>
            </div>

        );
    }
}

export default withRouter(Login);



// WEBPACK FOOTER //
// ./src/components/Login.js